'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFoundPage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Auth = _interopRequireDefault(require("Layouts/Auth"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _Routing = require("Functions/Routing");
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function NotFoundPage(props) {
  const [loading, setLoading] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    checkIfAllowed();
  }, []);
  let navigate = (0, _reactRouterDom.useNavigate)();
  const url_name = window.localStorage.getItem('requested_PAGE_CODE');
  const loader = loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['primary', 'bg-white']
  }) : undefined;
  let output = /*#__PURE__*/_react.default.createElement(_Auth.default, (0, _extends2.default)({
    page_title: "Page introuvable"
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-page__left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "u-full-width"
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    className: "auth-logo-link",
    href: "/"
  }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
    style: {
      width: '240px',
      maxWidth: '100%',
      margin: 'auto'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "u-full-width u-positioned"
  }, (0, _getFormStatus.default)({
    error: 'Votre page n\'a pas été trouvée. ' + '(Erreur 404).'
  }), loader))), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-page__right not-found"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "u-full-width"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "login-page__title"
  }, "Page introuvable"))));
  return output;
  async function checkIfAllowed() {
    try {
      var response = await (0, _ajaxRequest.default)((0, _Routing.action)('isAllowedPage'), {
        data: {
          url: url_name ? undefined : document.location.pathname,
          action_name: url_name
        }
      });
    } catch (req_error) {
      console.error(req_error);
      return setLoading(false);
    }
    setLoading(false);
    window.localStorage.setItem('requested_PAGE_CODE', '');
    if (response !== null && response !== void 0 && response.exist && (response === null || response === void 0 ? void 0 : response.allowed) === false) {
      navigate(URL('NotAllowedPage'));
    }
  }
}
